import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputPerilsSelectionList_checkboxListBody: {
			display: 'inline-flex',
			flexWrap: 'wrap',
			marginLeft: theme.spacing(-1.5),
		},
		inputPerilsSelectionList_checkboxListHelperText: {
			padding: theme.spacing(1, 0, 0, 0),
		},
		inputPerilsSelectionList_checkboxContainer: {

		},
		inputPerilsSelectionList_checkboxBody: {
			padding: theme.spacing(2, 1.5),
			minWidth: '275px',
		},
		inputPerilsSelectionList_perilsInputLabel: {
			padding: theme.spacing(0, 0, 1, 0),
		},
		inputPerilsSelectionList_perilsInputContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		inputPerilsSelectionList_perilsInputLabelWrapper: {
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		}
	});
});

export default useStyles;
